import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useNeedsEmailVerification = (): boolean => {
  const userInfo = useAppSelector(userSlice.selectLoggedInUserInfo);
  if (userInfo && Object.hasOwn(userInfo, 'isEmailVerified')) {
    return !userInfo.isEmailVerified;
  }
  // for users that are logged in but we don't have userinfo yet, assume an sso login so they don't need email verification
  return false;
};
